import { Component} from '@angular/core';

@Component({
    selector: 'app-about-section',
    templateUrl: './about-section.component.html',
    styleUrls: ['./about-section.component.scss'],
    standalone: false
})
export class AboutSectionComponent {
  constructor() { }
}
